import { App } from '@web/query/App';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  feature: PlatformFeatures | PlatformFeatures[];
  /**
   * For an array of features, whether all must be enabled ('all', default) or any one of them ('any').
   */
  match?: 'all' | 'any';
  invert?: boolean;
  /**
   * While the flags load, render the children hidden so their box is already in the layout and
   * nothing beside them moves when they show. Use where the feature is usually on.
   */
  holdWhileLoading?: boolean;
}

function RenderIfFeatureAvailable({ feature, children, match = 'all', invert, holdWhileLoading }: Props) {
  const { data, isLoading } = App.useFeatures();
  if (holdWhileLoading && isLoading) return <div className="invisible contents">{children}</div>;
  const features = Array.isArray(feature) ? feature : [feature];
  const available = match === 'any' ? features.some((f) => data?.[f]) : features.every((f) => data?.[f]);
  const needToShow = invert ? !available : available;

  return needToShow ? children : null;
}

export { RenderIfFeatureAvailable };
